if (!customElements.get('product-carousel-slider')) {
  class ProductCarouselSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-carousel__track');
      if (!this.track) return;

      this.isDragging = false;
      this.hasDragged = false;
      this.startX = 0;
      this.scrollStart = 0;

      this.bindDrag();
      this.bindATC();
    }

    bindDrag() {
      const t = this.track;

      t.addEventListener('mousedown', (e) => {
        this.isDragging = true;
        this.hasDragged = false;
        this.startX = e.pageX;
        this.scrollStart = t.scrollLeft;
        t.classList.add('is-grabbing');
      });

      document.addEventListener('mousemove', (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        const dx = e.pageX - this.startX;
        if (Math.abs(dx) > 5) this.hasDragged = true;
        t.scrollLeft = this.scrollStart - dx;
      });

      document.addEventListener('mouseup', () => {
        if (!this.isDragging) return;
        this.isDragging = false;
        t.classList.remove('is-grabbing');
      });

      t.addEventListener('click', (e) => {
        if (this.hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          this.hasDragged = false;
        }
      }, true);
    }

    bindATC() {
      this.querySelectorAll('[data-pc-form]').forEach((form) => {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          const btn = form.querySelector('button[type="submit"]');
          if (!btn || btn.classList.contains('is-loading')) return;
          this.addToCart(form, btn);
        });
      });
    }

    async addToCart(form, btn) {
      btn.classList.add('is-loading');

      try {
        const formData = new FormData(form);

        const res = await fetch('/cart/add', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: formData,
        });

        if (!res.ok) throw new Error(res.statusText);

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 2000);

        const onCartPage = window.location.pathname === '/cart';

        if (onCartPage) {
          setTimeout(() => window.location.reload(), 800);
        } else {
          await this.openCartDrawer();
        }
      } catch (err) {
        btn.classList.remove('is-loading');
        HTMLFormElement.prototype.submit.call(form);
      }
    }

    async openCartDrawer() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      try {
        // Fetch a fresh render of the cart-drawer section
        const res = await fetch(`${window.routes ? window.routes.cart_url : '/cart'}?section_id=cart-drawer`);
        const html = await res.text();
        const doc  = new DOMParser().parseFromString(html, 'text/html');

        // Replace the inner drawer content
        const newInner = doc.querySelector('#CartDrawer');
        const oldInner = document.querySelector('#CartDrawer');
        if (newInner && oldInner) {
          oldInner.innerHTML = newInner.innerHTML;
        }

        // Refresh the cart icon bubble
        const newBubble = doc.querySelector('#cart-icon-bubble');
        const oldBubble = document.querySelector('#cart-icon-bubble');
        if (newBubble && oldBubble) {
          oldBubble.innerHTML = newBubble.innerHTML;
        }

        // Re-attach overlay close listener then open
        const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));

        cartDrawer.classList.remove('is-empty');
        cartDrawer.open();
      } catch (err) {
        // Fallback: just open whatever state the drawer is in
        cartDrawer.open();
      }
    }
  }

  customElements.define('product-carousel-slider', ProductCarouselSlider);
}
